type Props = {
    replySuggestion: string
    onSelection: (message: string) => void
}

/**
 * Component to display suggested replies which are editable and sendable
 */
export default function SuggestedReply(props: Props) {
    const { replySuggestion, onSelection } = props

    return (
        <div className="flex items-start space-x-4">
            <div className="min-w-0 flex-1 pt-3">
                <form action="#" className="relative flex flex-row">
                    <div className="group flex flex-grow cursor-pointer rounded-lg border-white bg-ink-200 opacity-100 hover:border-none hover:bg-arwen-600 hover:shadow-xl">
                        <div
                            className="m-0.5 flex-grow overflow-hidden rounded-md bg-white shadow-md ring-ink-900"
                            onClick={() => {
                                onSelection(replySuggestion)
                            }}
                            data-tooltip-id="tooltip-id"
                            data-tooltip-content={'Click to edit and send'}
                        >
                            <label htmlFor="comment" className="sr-only">
                                Your response
                            </label>
                            <div className="ml-2 mr-1.5 resize-none border-0 py-1.5 text-ink-900 placeholder:text-ink-400">
                                {replySuggestion}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
